import React from 'react';
import './Events.css';

function Events() {
  return (
    <div className="container">
      <h1 className="page-title">Важные События</h1>
      
      <div className="events-coming-soon">
        <div className="coming-soon-icon">📅</div>
        <h2>Раздел в разработке</h2>
        <p>
          Здесь будет календарь с отметками ключевых событий жизни Софии.
          Мы отметим первую улыбку, первый зуб, первые шаги и другие важные моменты.
        </p>
      </div>
    </div>
  );
}

export default Events; 